import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Consult from "./consult";
import Experience from "./experience";
import Mount from "./mount";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function Board50(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="neat.board50, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat.board50"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, board50, neat board50, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>All-in-One, AI</span> 화상회의 디바이스
        </div>
        <div className={style.device_title}>
          <img
            className={style.small_title}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/title_neat_board_50${isMobile ? "_m" : ""}.webp`
            }
            alt="board50"
          />
        </div>
      </div>
      <div className={style.device_text}>
        개방된 공간, 회의실을 위한
        <br />
        최적의 화상회의 장비
      </div>

      <div className={style.device_img_list}>
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/board50_1${isMobile ? "_m" : ""}.webp`
          }
          alt="board50"
        />
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/board50_2${isMobile ? "_m" : ""}.webp`
          }
          alt="board50"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div
          className={style.device_description_img_box}
          style={{ paddingTop: "0px", justifyContent: "center" }}
        >
          <div className={style.device_description_img_wrap}>
            {isMobile ? (
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/board50_reddot_2024_m.webp`
                }
                alt="board50_reddot_2024"
              />
            ) : (
              <>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/board50_device.png"
                  }
                  alt="board50"
                />
                <div className={style.device_description_reddot_wrap}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/device/neat/reddot_2024_white.webp"
                    }
                    alt="reddot"
                  />
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/device/neat/reddot_2024_sp.webp"
                    }
                    alt="reddot"
                  />
                </div>
              </>
            )}
          </div>

          <div className={style.device_description_text_box}>
            테이블 스탠드 & 액티브 마커 포함
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/all_in_one${isMobile ? "_m" : ""}.webp`
                  }
                  alt="all_in_one"
                />
              </div>
              <div className={style.device_description_text}>
                <span>통합 올인원 디바이스</span> : 카메라 · 마이크 · 스피커 ·
                터치스크린
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/touch${isMobile ? "_m" : ""}.webp`
                  }
                  alt="touch"
                />
              </div>
              <div className={style.device_description_text}>
                선명하고 생생한 화질을 제공{" "}
                <span>( 50인치 4K 터치스크린 디스플레이 )</span>
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/window${isMobile ? "_m" : ""}.webp`
                  }
                  alt="window"
                />
              </div>
              <div className={style.device_description_text}>
                <span>두 개</span>의 Neat Board50을 함께 사용하고 동일한
                세션에서 <span>다른 앱 실행 가능</span>
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Board50 <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_board50_1${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  유연한 업무를 위해 설계된{isMobile ? <br /> : " "}Board 50
                </div>
              </div>
              <div className={style.device_features_text}>
                {`50인치 크기의 4K 터치스크린 디스플레이를 갖추고 있어, 선명하고 생생한 화면을 제공하며,${
                  isMobile ? " " : "\n"
                }` +
                  `카메라/마이크/스피커/터치스크린 디스플레이가 하나로 통합된 올인원 장비 입니다.\n` +
                  `1:1 협업 및 회의를 하든, 소규모 그룹으로 하든, 대규모 모임을 주최하든 board50은${
                    isMobile ? " " : "\n"
                  }` +
                  `빠르게 적응하여 아이디어를 충족하거나 표현합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_board50_2${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  무한한 가능성
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat board50는 비즈니스 애플리케이션 허브를 통해 다양한 앱${
                  isMobile ? " " : "\n"
                }` +
                  `(예 : Slack, Miro 등)을 지원하며, 이를 통해 팀원 간의 효율적인${
                    isMobile ? " " : "\n"
                  }` +
                  `협업을 도모합니다. 두 개의 장비를 동시에 사용하여 각기 다른 앱을${
                    isMobile ? " " : "\n"
                  }` +
                  `실행 할 수 있으며 이를 통해 더 강력하고 몰입감 있는 협업 환경을 조성합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_board50_3${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  액티브 마커 ( Neat Active Maker )
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Active Marker는 압력 감지 기능을 갖추고 있어 자연스러운 필기와 스케치를${
                  isMobile ? " " : "\n"
                }` +
                  `지원합니다. 별도의 페어링이나 충전이 필요 없으며, 손쉬운 사용이 가능합니다.`}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Mount />
      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/spec_board50_1${isMobile ? "_m" : ""}.png`
              }
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_board50_2${isMobile ? "_m" : ""}.png`
                }
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_board50_3${isMobile ? "_m" : ""}.png`
                }
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_text_wrap}
          style={{ borderRadius: "20px 20px 0 0" }}
        >
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>50인치 정전식 멀티터치 LED 화면</span>
                <span>Ultra HD 4K(3840 x 2160 화면 해상도)</span>
                <span>16:9 화면비</span>
                <span>눈부심 방지 및 지문 방지 코팅</span>
                <span>유리 표면 경도 7H</span>
                <span>USB-C 90W 전원공급(PD)</span>
                <span>보조 디스플레이 지원</span>
                <span>카메라 LED / 시스템 LED</span>
                <span>주변광 센서</span>
                <span>Neat Active Marker</span>
                <span>테이블 스탠드</span>
                <span>어댑티브 스탠드(옵션)</span>
                <span>어댑티브 마운트 (옵션)</span>
                <span>벽걸이(옵션)</span>
                <span>Neat Pad 컨트롤러(옵션)</span>
                <span>Neat Pad 일정 디스플레이(옵션)</span>
                <span>온도, 습도, CO2 및 VOC용 센서 (*)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "40px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>4x 디지털 줌(최대 8x 디지털 줌)</span>
                <span>고정 렌즈, 무한 초점</span>
                <span>F 값: 2.8</span>
                <span>50MP 캡처 해상도</span>
                <span>113도 수평 시야</span>
                <span>자동 인물 프레이밍</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "45px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>WiFi 6</span>
                <span>Bluetooth (MS Teams Proximity Join 용)</span>
                <span>AC 파워 (파워내장형)이더넷</span>
                <span>USB-C (공유 및 BYOD모드를 위한 DP Alt 모드 지원)</span>
                <span>HDMI-입력 (화면공유용)</span>
                <span>HDMI-출력 (듀얼 스크린용)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>진동 방지 드라이버</span>
                <span>초음파 트위터</span>
                <span>센서 마이크 5개</span>
                <span>빔포밍 마이크 5개</span>
                <span>에코 제거</span>
                <span>소음 억제</span>
                <span>오토 게인 컨트롤</span>
                <span>잔향 제거</span>
              </div>
            </div>
          </div>
        </div>

        <div className={style.device_spec_mount_wrap}>
          <div className={style.device_spec_mount_horizon}></div>
          <div className={style.device_spec_mount_title}>
            Neat Board 50 Mount
          </div>

          <div className={style.device_spec_mount_list}>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                테이블 스탠드 (기본포함)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_board50_mount_1${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_1"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>너비: 44.8인치(1138mm)</span>
                  <span>높이: 29.3인치(745mm)</span>
                  <span>깊이: 10.3인치(261mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 52파운드(23.5kg)</span>
                  <span>테이블 스탠드 순 중량: 2파운드(0.9kg)</span>
                </div>
              </div>
            </div>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                벽 마운트 (옵션)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_board50_mount_2${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_2"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>너비: 44.8인치(1138mm)</span>
                  <span>높이: 28.2인치(716mm)</span>
                  <span>깊이: 3.6인치(92mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 59.5파운드(27kg)</span>
                  <span>벽걸이 순 중량: 9.7파운드(4.4kg)</span>
                </div>
              </div>
            </div>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                어댑티브 마운트(옵션)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_board50_mount_3${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_3"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>너비: 44.8인치(1138mm)</span>
                  <span>높이: 28.2인치(716mm)</span>
                  <span>깊이: 3.8인치(96mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 71.9파운드(32.6kg)</span>
                  <span>어댑티브 마운트 순 중량: 22.0파운드(10kg)</span>
                </div>
              </div>
            </div>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                어댑티브 스탠드(옵션)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_board50_mount_4${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_4"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>너비: 44.8인치(1138mm)</span>
                  <span>최소 높이: 68.8인치(1747mm)</span>
                  <span>최대 높이: 73.8인치(1874mm)</span>
                  <span>깊이: 36인치(915mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 136.7파운드(62kg)</span>
                  <span>순 중량 어댑티브 스탠드: 39.4kg(86.7파운드)</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/spec_board50_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>50″</div>
            <div className={style.device_spec_icon_label}>4K 액티브 터치</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>113° FOV</div>
            <div className={style.device_spec_icon_label}>광각 카메라</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>50MP</div>
            <div className={style.device_spec_icon_label}>캡처 해상도</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>4x</div>
            <div className={style.device_spec_icon_label}>디지털 줌</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.micArray_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mic_array${isMobile ? "_m" : ""}.webp`
                }
                alt="mic"
              />
            </div>
            <div className={style.device_spec_icon_label}>5 마이크 어레이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.vibration_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/vibration${isMobile ? "_m" : ""}.webp`
                }
                alt="vibration"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              왜곡이 적은 스피커
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.activeMarker_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/active_marker${isMobile ? "_m" : ""}.webp`
                }
                alt="active_marker"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              깔끔한 액티브 마커
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.wifi_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/wifi${isMobile ? "_m" : ""}.webp`
                }
                alt="wifi"
              />
            </div>
            <div className={style.device_spec_icon_label}>와이파이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.air_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/air${isMobile ? "_m" : ""}.webp`
                }
                alt="air"
              />
            </div>
            <div className={style.device_spec_icon_label}>공기질 센서</div>
          </div>
        </div>

        <Warranty />
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Board50;
